export default "__VITE_ASSET__a8c09a8e__"